/**
 * Banner 1025 — BDU Hero
 * Slides carry their own desktop/mobile background, title, subtitle and colours.
 * Accreditation badges are section level (`metadata_1`) and render on every slide
 * that has a title, matching the BDU v1 Hero.
 */

export const BANNER_1025_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Carousel slides",
    metadata_1: "Accreditation badges",
  },

  DEFAULT_ROW: {
    id: "1",
    image: "",
    alt_image: "Bharathidasan University Online",
    mobile_image: "",
    mobile_alt_image: "Bharathidasan University Online",
    title: "Bharathidasan University Online",
    subtitle: "Creating Tomorrow's Leaders and Innovators Today.",
    title_color: "#FFFFFF",
    subtitle_color: "#FFFFFF",
    priority: 1,
    status: true,
  },

  DEFAULT_ROW_1: {
    id: "1",
    image: "",
    alt_image: "",
    priority: 1,
    status: true,
  },

  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "slide_frequency",
      label: "Slide interval (ms)",
      value: 5000,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "5000",
      required: true,
      defaultValue: 5000,
    },
    {
      fieldName: "hero_section_height",
      label: "Section height from 768px up (px) — below that it is fixed at 402px",
      value: 540,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "540",
      defaultValue: 540,
    },
    {
      fieldName: "gradient_color_1",
      label: "Overlay panel gradient — start (first slide, 768px and up)",
      value: "#13344F",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#13344F",
    },
    {
      fieldName: "gradient_color_2",
      label: "Overlay panel gradient — end (first slide, 768px and up)",
      value: "#77B6EB",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#77B6EB",
    },
    {
      fieldName: "background_color",
      label: "Overlay panel fill below 768px (first slide)",
      value: "#22405ADB",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#22405ADB",
    },
    {
      fieldName: "apply_now_show",
      label: "Show CTA button",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_text",
      label: "CTA label",
      value: "Enroll Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enroll Now",
      defaultValue: "Enroll Now",
    },
    {
      fieldName: "apply_now_is_cta",
      label: "Is CTA (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = open lead capture popup instead of the CTA URL",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "apply_now_link",
      label: "CTA URL (used when Is CTA is off)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/contact or https://…",
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_3",
      label: "CTA gradient — start",
      value: "#FF0013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FF0013",
    },
    {
      fieldName: "gradient_color_4",
      label: "CTA gradient — end",
      value: "#990013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#990013",
    },
    {
      fieldName: "apply_now_color",
      label: "CTA text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "horizontal_stripe_color",
      label: "Accreditation bar background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Banner status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Slide background (desktop)",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Desktop background image",
      defaultValue: "",
    },
    {
      header: "Background alt (desktop)",
      fieldName: "alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Slide background (mobile)",
      fieldName: "mobile_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Mobile background image (optional — uses desktop if empty)",
      defaultValue: "",
    },
    {
      header: "Background alt (mobile)",
      fieldName: "mobile_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Title",
      fieldName: "title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Slide with no title renders image only (no overlay panel)",
      defaultValue: "",
    },
    {
      header: "Subtitle",
      fieldName: "subtitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Title colour",
      fieldName: "title_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Subtitle colour",
      fieldName: "subtitle_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS_1: [
    {
      header: "Badge image",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload accreditation badge",
      defaultValue: "",
    },
    {
      header: "Badge alt",
      fieldName: "alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
